import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=7d395435&scoped=true&"
import script from "./SectionHeader.vue?vue&type=script&lang=js&"
export * from "./SectionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d395435",
  null
  
)

export default component.exports